export default __webpack_public_path__ + "static/media/icon-6.e9722f26.png";